// src/components/Auth/PhoenixLogin.js
import React, { useState } from 'react';
import { authApi } from '../../api'; 
import { Link as RouterLink } from 'react-router-dom';

const PhoenixLogin = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await authApi.login(username, password);

            if (res.data.step === 'code_required') {
                onLoginSuccess(res.data.username); 
            }
        } catch (err) {
            alert("Login attempt failed. Check credentials or contact admin.");
            console.error("Login Error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-card">
            {/* Pulsing Security Shield Icon */}
            <div className="auth-shield-icon-wrapper">
                <i className="fas fa-user-shield"></i>
            </div>

            <h2>Admin Portal</h2>
            <div className="auth-tagline">Authorized Access Only</div>

            <form onSubmit={handleSubmit} className="auth-form">
                <div className="auth-input-group">
                    <label>Username</label>
                    <div className="auth-input-box">
                        <i className="fas fa-user input-left-icon"></i>
                        <input
                            type="text"
                            placeholder="Enter admin username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoComplete="username"
                        />
                    </div>
                </div>

                <div className="auth-input-group">
                    <label>Password</label>
                    <div className="auth-input-box">
                        <i className="fas fa-lock input-left-icon"></i>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                            className="password-input-field"
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowPassword((prev) => !prev)}
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            title={showPassword ? "Hide password" : "Show password"}
                            tabIndex="-1"
                        >
                            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                        </button>
                    </div>
                </div>

                <button type="submit" className="admin-btn-primary auth-submit-btn" disabled={loading}>
                    {loading ? (
                        <>
                            <i className="fas fa-circle-notch fa-spin"></i> Authenticating...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-key"></i> Authenticate &amp; Send 2FA
                        </>
                    )}
                </button>
            </form>

            <p className="auth-footer-link">
                Need credentials? <RouterLink to="/signup">Request Admin Access</RouterLink>
            </p>
        </div>
    );
};

export default PhoenixLogin;